module.exports = __webpack_public_path__ + "static/img/shheader.4d3b272.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shheader.jpg
// module id = 69wl
// module chunks = 1